import * as FIELD_NAME from 'constant/form-item-names'
import { Form } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
import TagSelectInput from 'view/component/form-items/tag-select-input'
import { connect } from 'react-redux'
import _ from 'lodash'

const TagSelect = ({ tags }) => {
  const handleUpdate = (prevValues, currentValues) => prevValues.category_uuid !== currentValues.category_uuid
  return (
    <Form.Item
      noStyle
      shouldUpdate={handleUpdate}
    >
      {({ getFieldValue }) => {
        const categoryUuids = getFieldValue(FIELD_NAME.CATEGORY_UUID)
        if (!categoryUuids?.length) {
          return
        }

        const tagsFiltered = tags.results?.map((tag) => {
          const filter = tag.category.filter(({ uuid }) => categoryUuids.includes(uuid))
          const subcatFilter = tag.sub_category.filter(({ uuid }) => categoryUuids.includes(uuid))
          if (!_.isEmpty(filter) || !_.isEmpty(subcatFilter)) {
            return tag
          }

          return null
        })
        return _.compact(tagsFiltered)?.length
          ? (
            <TagSelectInput tags={_.compact(tagsFiltered)} />
          )
          : null
      }}
    </Form.Item>
  )
}

TagSelect.propTypes = {
  tags: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ])
}

const mapStateToProps = (state) => ({
  tags: state.tag.tags
})

export default connect(mapStateToProps)(TagSelect)
